import React from 'react'
import { PLATFORM_LOGO, PLATFORM_NAME } from '../../config/brand'

interface WebullLogoProps {
  height?: number
  className?: string
}

const WebullLogo: React.FC<WebullLogoProps> = ({ height = 32, className = '' }) => {
  return (
    <img
      src={PLATFORM_LOGO}
      alt={PLATFORM_NAME}
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
      draggable={false}
    />
  )
}

export default WebullLogo
